import { Link } from "react-router-dom";
import Notifications from "../../components/notifications/Notifications";

const TopbarSubscribers: React.FC = () => {

    return (
        <div className="container-fluid">

            <div className="d-flex justify-content-between main-card-tob-navbar pb-1 pt-2 mt-2">
                <ul className="navbar-nav flex-row">
                    <li className="nav-item dropdown mr-4">
                        <a
                            className="nav-link dropdown-toggle"
                            // href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Example 1
                        </a>
                        <div className="dropdown-menu">
                            <Link className="dropdown-item" to="#">
                                Option 1
                            </Link>
                            <Link className="dropdown-item" to="#">
                                Option 2
                            </Link>
                        </div>
                    </li>
                    <li className="nav-item dropdown mr-4">
                        <a
                            className="nav-link dropdown-toggle"
                            // href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Example 2
                        </a>
                        <div className="dropdown-menu">
                            <Link className="dropdown-item" to="#">
                                Option 1
                            </Link>
                            <Link className="dropdown-item" to="#">
                                Option 2
                            </Link>
                            <Link className="dropdown-item" to="#">
                                Option 3
                            </Link>
                        </div>
                    </li>
                    <li className="nav-item dropdown mr-4">
                        <a
                            className="nav-link dropdown-toggle"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Example 3
                        </a>
                        <div className="dropdown-menu">
                            <Link className="dropdown-item" to="#">
                                Option 1
                            </Link>
                        </div>
                    </li>
                </ul>
                <Notifications />
            </div>
        </div>
    );
}

export default TopbarSubscribers;